(function () {
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var headerMenuSelector = 'header-drawer details[open], details.menu-drawer-container[open]';
  var desktopFilterSelector = '#FacetFiltersForm details.js-filter[open], #FacetFiltersPillsForm details.js-filter[open]';

  function closeDetails(details) {
    if (!details) return;

    details.removeAttribute('open');
    details.classList.remove('menu-opening');
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');

    details.querySelectorAll('details[open]').forEach(function (child) {
      child.removeAttribute('open');
      child.classList.remove('menu-opening');
      var childSummary = child.querySelector('summary');
      if (childSummary) childSummary.setAttribute('aria-expanded', 'false');
    });
    details.querySelectorAll('.submenu-open').forEach(function (element) {
      element.classList.remove('submenu-open');
    });
  }

  function closeMobileFilters(details) {
    closeDetails(details);
    document.body.classList.remove('overflow-hidden-mobile');
    document.body.classList.remove('overflow-hidden-tablet');
  }

  function closeAllMobileFilters() {
    document.querySelectorAll('menu-drawer.mobile-facets__wrapper > details[open]').forEach(function (details) {
      closeMobileFilters(details);
    });
  }

  function closeDesktopFilters(exceptDetails) {
    document.querySelectorAll(desktopFilterSelector).forEach(function (details) {
      if (details !== exceptDetails) {
        closeDetails(details);
      }
    });
  }

  function closeAllFilters() {
    closeAllMobileFilters();
    closeDesktopFilters();
  }

  function isHeaderMenuOpen() {
    return Boolean(document.querySelector(headerMenuSelector));
  }

  function syncHeaderMenuState() {
    var headerMenuOpen = isHeaderMenuOpen();

    document.body.classList.toggle('nicla-drawer-open', headerMenuOpen);
    document.body.classList.toggle('nicla-menu-open', mobileQuery.matches && headerMenuOpen);

    if (headerMenuOpen) {
      closeAllFilters();
    }
  }

  function closeDesktopWhenTouchingAnotherArea(event) {
    if (mobileQuery.matches) return;

    var currentDetails = event.target.closest('#FacetFiltersForm details.js-filter, #FacetFiltersPillsForm details.js-filter');
    closeDesktopFilters(currentDetails);
  }

  function closeWhenTouchingOutside(event) {
    if (!mobileQuery.matches) return;

    var openDetails = document.querySelector('menu-drawer.mobile-facets__wrapper > details[open]');
    if (!openDetails || openDetails.contains(event.target)) return;

    closeMobileFilters(openDetails);
  }

  document.addEventListener('pointerdown', closeWhenTouchingOutside, true);
  document.addEventListener('pointerdown', closeDesktopWhenTouchingAnotherArea, true);
  document.addEventListener('click', closeWhenTouchingOutside, true);
  document.addEventListener('click', function () {
    window.setTimeout(syncHeaderMenuState, 0);
  }, true);
  document.addEventListener('keyup', function () {
    window.setTimeout(syncHeaderMenuState, 0);
  }, true);
  window.addEventListener('resize', syncHeaderMenuState);
  window.addEventListener('pagehide', closeAllFilters);
  window.addEventListener('beforeunload', closeAllFilters);
  window.addEventListener('popstate', closeAllFilters);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') closeAllFilters();
  });

  if (window.MutationObserver) {
    new MutationObserver(syncHeaderMenuState).observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['open']
    });
  }

  syncHeaderMenuState();
})();
